import { render, staticRenderFns } from "./wanGongAlbum.vue?vue&type=template&id=715ccd10&scoped=true&"
import script from "./wanGongAlbum.vue?vue&type=script&lang=js&"
export * from "./wanGongAlbum.vue?vue&type=script&lang=js&"
import style0 from "./wanGongAlbum.vue?vue&type=style&index=0&lang=css&"
import style1 from "./wanGongAlbum.vue?vue&type=style&index=1&id=715ccd10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715ccd10",
  null
  
)

export default component.exports